module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// /Users/gtirby/develop/~/axios/index.js
// module id = 60
// module chunks = 0